<template>
  <div class="sessione-uoc-view p-4">

    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
      <div class="loading-text">Caricamento in corso...</div>
    </div>

    <!-- Toast -->
    <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />
    <div class="card mb-3 shadow-sm">
      <div class="card-body d-flex align-items-center justify-content-between">

        <div class="d-flex align-items-center">
          <h5 class="mb-0 me-2">
            Sessione UOC #{{ uocId }} del {{ formatDateDDMMYYYY(sessione?.date) }}
          </h5>

          <button class="btn btn-outline-secondary btn-sm p-1" style="border-color: #D3D3D3; font-size: 0.8rem;"
            @click="showFilters = !showFilters">
            <i class="bi bi-funnel-fill"></i>
          </button>
        </div>

        <button class="btn btn-outline-secondary btn-sm p-1" @click="changeView('UOCArchiveView')"
          title="Torna all'elenco">
          <i class="bi bi-arrow-left"></i>
        </button>

      </div>
    </div>

    <transition name="slide-fade" @enter="enter" @leave="leave">
      <CommonUOCFilters v-show="showFilters" :allTopics="allTopics" :allLegislations="allLegislations"
        :allArticles="allArticles" :allRegions="allRegions" :allYears="allYears" v-model:selectedTopics="selectedTopics"
        v-model:selectedLegislation="selectedLegislation" v-model:selectedArticles="selectedArticles"
        :isGestore="isGestore || isLegalExpert" @update:selectedLegislation="onLegislationChange"
        @update:selectedTopics="val => selectedTopics = val" @update:selectedArticles="val => selectedArticles = val"
        @filter="applyFilter" />
    </transition>

    <div class="mb-3 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <label class="me-2 mb-0">Elementi per pagina:</label>
        <select class="form-select w-auto" v-model.number="pagination.perPage" @change="loadQuestions(1)">
          <option v-for="n in [10, 25, 50, 100, 500]" :key="n" :value="n">{{ n }}</option>
        </select>
      </div>
      <div class="d-flex align-items-center gap-2">
        <button v-if="canJoinUoc" class="btn btn-primary btn-sm rounded-pill px-3 py-2" @click="joinUoc">
          <i class="bi bi-camera-video me-1"></i> Partecipa a UOC
        </button>

        <button class="btn btn-outline-secondary btn-sm rounded-pill px-3 py-2" @click="downloadPdf"
          :disabled="isDownloading || selectedQuestions.length === 0">
          <span v-if="!isDownloading">
            <i class="bi bi-file-earmark-pdf me-1"></i> Scarica PDF
          </span>
          <span v-else>
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Generazione in corso...
          </span>
        </button>
      </div>
    </div>

    <UOCTable :questions="questions" :pagination="pagination" :sort-field="sortField" :sort-direction="sortDirection"
      :state-icons="stateIcons" @page-change="loadQuestions" @sort="handleSort" @open-detail="openQuestionDetail"
      @change-view="changeView" @update:selected-questions="selectedQuestions = $event" :show-state-column="true" />
  </div>
</template>

<script>
import { ref } from 'vue';
import UOCTable from './partials/UOCTable.vue';
import toastable from '../../../mixins/toastable';
import ToastDialog from '../../../components/common/ToastDialog.vue';
import CommonUOCFilters from './partials/CommonUOCFilters.vue';

export default {
  name: 'SessioneUOCView',
  components: {
    UOCTable,
    ToastDialog,
    CommonUOCFilters
  },
  mixins: [toastable],
  props: ['elementId'],
  data() {
    return {
      questions: [],
      pagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        lastPage: 1
      },
      showDetailModal: false,
      isGestore: false,
      isLegalExpert: false,
      sortField: 'created_at',
      sortDirection: 'desc',
      allTopics: [],
      allLegislations: [],
      allArticles: [],
      selectedTopics: [],
      selectedLegislation: null,
      selectedArticles: [],
      toastTitle: '',
      toastMessage: '',
      toastError: false,
      filterId: '',
      filterObject: '',
      filterOrganization: '',
      filterText: '',
      filterRegion: [],
      filterYear: [],
      allYears: [],
      isLoading: true,
      isDownloading: false,
      showFilters: false,
      filterCreatedFrom: '',
      filterCreatedTo: '',
      filterSendingFrom: '',
      filterSendingTo: '',
      allSearchIds: [],
      uocId: null,
      sessione: null,
      selectedQuestions: []
    };
  },

  /**created() {
    this.loadQuestions(1);
  },*/

  async mounted() {
    await this.loadAvailableYears();
    await this.loadAllRegions();
    await this.loadAllTopics();
    await this.loadAllLegislations();
    await this.loadUocSession();
    await this.loadQuestions();
  },
  async created() {
    console.log("caricamento articoli");
    if (!this.$root.contents) {
      await this.$root.fetchContents()
    }
  },
  watch: {
    elementId(newId) {
      if (newId) this.loadUocSession();
    }
  },

  computed: {
    canJoinUoc() {
      if (!this.sessione?.date || !this.sessione?.conference_link) return false;

      const sessionDate = new Date(this.sessione.date);
      sessionDate.setHours(23, 59, 59, 999);

      return sessionDate > new Date();
    }
  },

  methods: {
    joinUoc() {
      if (!this.sessione?.conference_link) return;

      window.open(this.sessione.conference_link, '_blank', 'noopener,noreferrer');
    },
    changeView(viewName, id) {
      console.log('Evento ricevuto:', viewName, id);
      this.$emit('change-view', viewName, id);
    },
    formatDateDDMMYYYY(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    async loadUocSession() {
      if (!this.elementId) return;

      this.isLoading = true;
      try {
        const response = await this.$root.$api.get(`/uoc/sessions/${this.elementId}`);
        this.sessione = response.data.data;
      } catch (err) {
        this.showErrorToast('Errore', 'Impossibile caricare i dati della sessione UOC');
        this.sessione = null;
      } finally {
        this.isLoading = false;
      }
    },
    /**async loadQuestions(page = 1) {
      this.isLoading = true;

      try {
        const params = {
          page: this.pagination.page,
          per_page: this.pagination.perPage,
          sortField: this.sortField,
          sortDirection: this.sortDirection,

          uoc_session_id: this.elementId
        };

        const res = await this.$root.$api.get('/uoc/questions-uoc', { params });

        this.questions = res.data.data;
        this.pagination = {
          currentPage: res.data.current_page,
          perPage: res.data.per_page,
          total: res.data.total,
          lastPage: res.data.last_page
        };

      } catch (e) {
        this.$root.$toast.error('Errore nel caricamento della sessione UOC');
      } finally {
        this.isLoading = false;
      }
    },*/

    handleSort({ field, direction }) {
      this.sortField = field;
      this.sortDirection = direction;
      this.loadQuestions(1);
    }
    ,
    async loadQuestions(page = 1) {
      this.isLoading = true;
      this.selectedQuestions = [];
      try {
        const params = {
          page: page,
          per_page: this.pagination.perPage,
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          room: this.roomView,
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id_v: this.selectedLegislation ?? '',
          id: this.filterId || '',
          object: this.filterObject || '',
          organization_desc: this.filterOrganization || '',
          text: this.filterText || '',
          region: this.filterRegion.join(',') || '',
          year: this.filterYear.join(',') || '',
          created_from: this.filterCreatedFrom || '',
          created_to: this.filterCreatedTo || '',
          sending_from: this.filterSendingFrom || '',
          sending_to: this.filterSendingTo || '',
          uoc_session_id: this.elementId
        };
        const response = await this.$root.$api.get('/uoc/questions-uoc', { params });
        const questionsWithArticleTitles = response.data.data.map(q => {
          const newQ = { ...q };

          const articlesArray = this.$root.contents?.articles || [];

          newQ.articles = (q.articles || []).map(a => {
            const content = articlesArray.find(c => c.id === a.id);
            if (!content || !content.versions || !content.versions.length) return { ...a, title: null };

            const lastVersion = content.versions.reduce(
              (prev, curr) => (curr.id > prev.id ? curr : prev),
              content.versions[0]
            );

            return { ...a, title: lastVersion.title };
          });

          return newQ;
        });
        this.questions = questionsWithArticleTitles;

        this.pagination = {
          currentPage: response.data.current_page,
          perPage: response.data.per_page,
          total: response.data.total,
          lastPage: response.data.last_page
        };
        this.allSearchIds = response.data.allSearchIds || [];
        this.uocId = this.elementId

      } catch (error) {
        this.showErrorToast('Errore', 'Errore nel caricamento dei quesiti');
      } finally {
        this.isLoading = false;
      }
    },
    async loadAllTopics() {
      const response = await this.$root.$api.get('/questions/topics');
      this.allTopics = response.data;
    },
    async loadAllLegislations() {
      //this.allLegislations = Object.values(this.$root.dlgs || {});
      const legislations = Object.values(this.$root.dlgs || {});

      const activeLegislation = legislations.filter(l => l.end === null);

      this.allLegislations = [
        {
          id: 0,
          begin: null,
          end: null,
          legislation: null,
          published_at: null,
          deleted_at: null,
          created_at: null,
          updated_at: null,
          title: "D.lgs 50/2016"
        },
        ...activeLegislation
      ];
    },
    async loadAllRegions() {
      const response = await this.$root.$api.get('/questions/regions');
      this.allRegions = response.data;
    },
    async loadAvailableYears() {
      const response = await this.$root.$api.get('/questions/years');
      this.allYears = response.data;
    },
    handleSort({ field, direction }) {
      this.sortField = field;
      this.sortDirection = direction;
      this.loadQuestions(1);
    },
    applyFilter(filters) {
      this.filterId = filters.id || '';
      this.filterObject = filters.object || '';
      this.filterOrganization = filters.organization || '';
      this.filterText = filters.text || '';
      this.filterRegion = filters.region || '';
      this.filterYear = filters.year || '';
      this.filterState = filters.state || '';
      this.filterCreatedFrom = filters.created_from || '';
      this.filterCreatedTo = filters.created_to || '';
      this.filterSendingFrom = filters.sending_from || '';
      this.filterSendingTo = filters.sending_to || '';
      this.loadQuestions(1);
    },
    async onLegislationChange(newLegId) {
      this.selectedLegislation = newLegId;
      this.selectedArticles = [];
      if (!newLegId) {
        this.allArticles = [];
        return;
      }

      const allArticles = Object.values(this.$root.contents?.articles || [])
        .filter(a => !a.deleted_at && a.versions && a.versions.length > 0);

      const legislation = this.allLegislations.find(l => l.id === newLegId);

      if (!legislation) {
        this.allArticles = [];
        return;
      }

      this.allArticles = this.filterArticlesByLegislationDate(allArticles, legislation);

      this.allArticles.sort((a, b) => a.id - b.id);

      this.allArticles = this.allArticles.map(a => ({
        ...a,
        title: a.versions[a.versions.length - 1]?.title || ''
      }));

    },
    async downloadPdf() {
      this.isDownloading = true;
      try {


        const idsToPrint = this.selectedQuestions.length > 0
          ? this.selectedQuestions
          : this.allSearchIds;

        console.log(idsToPrint);

        const params = {
          ids: idsToPrint.join(','),
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id_v: this.selectedLegislation ?? '',
          id: this.filterId || '',
          object: this.filterObject || '',
          organization_desc: this.filterOrganization || '',
          text: this.filterText || '',
          region: this.filterRegion.join(',') || '',
          year: this.filterYear.join(',') || '',
          state: Array.isArray(this.filterState) ? this.filterState.join(',') : '',
          created_from: this.filterCreatedFrom || '',
          created_to: this.filterCreatedTo || '',
          sending_from: this.filterSendingFrom || '',
          sending_to: this.filterSendingTo || ''
        };

        if (this.selectedQuestions.length > 0) {
          params.ids = this.selectedQuestions.join(',');
        }
        await this.$root.$api.get('/questions/pdf/exportUOC', { params });
        this.showSuccessToast('PDF in preparazione. Ti verrà notificato quando sarà pronto.');
        this.$root.triggerPdfPolling();

      } catch (error) {
        this.showErrorToast('Errore', 'Impossibile scaricare il PDF');
      } finally {
        this.isDownloading = false;
      }
    },
    filterArticlesByLegislationDate(allArticles, legislation, searchDate = null) {
      const activeDate = searchDate ? new Date(searchDate) : new Date();

      return allArticles
        .map(article => {
          const allVersions = article.versions.map(v => ({ ...v.version, frontendVersionId: v.id }));
          let activeVersions = allVersions.filter(v => {
            const begin = new Date(v.begin);
            const end = v.end ? new Date(v.end) : null;
            if (end) return activeDate >= begin && activeDate <= end;
            return activeDate >= begin;
          });
          if (activeVersions.length === 0 && allVersions.length > 0) {
            const sortedByBeginDesc = allVersions.sort((a, b) => new Date(b.begin) - new Date(a.begin));
            activeVersions = [sortedByBeginDesc[0]];
          }
          let filteredVersions = activeVersions;
          if (activeVersions.length > 1) {
            const mainVersion = activeVersions.find(v => {
              const begin = new Date(v.begin);
              const end = v.end ? new Date(v.end) : null;
              return (!end && begin <= activeDate) || (end && begin <= activeDate && end >= activeDate);
            }) || activeVersions[0];
            filteredVersions = activeVersions.filter(v => v.title === mainVersion.title);
          }
          const finalVersions = article.versions.filter(av =>
            filteredVersions.some(fv => fv.id === av.version.id)
          );
          return { ...article, versions: finalVersions };
        })
        .filter(article => article.versions.length > 0)
        .sort((a, b) => a.id - b.id);
    }
  }
};
</script>
<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}
</style>